var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.442,
    height: 31.704,
    viewBox: "0 0 40.442 31.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_12",
    "data-name": "Uni\\xE3o 12",
    d: "M23.626,22.42H30.8V29.7ZM9.44,18.88A9.44,9.44,0,0,1,9.44,0H29a9.44,9.44,0,0,1,0,18.88Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLine);
export default __webpack_public_path__ + "static/media/chat-line.89ef2a422d7695f44e458e76fb47d819.svg";
export { ForwardRef as ReactComponent };